import "element-plus/theme-chalk/dark/css-vars.css";
import "./index.css";
import "video.js/dist/video-js.css";

import { initTheme } from "@/composables/theme";
initTheme();

import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";

import { autofocus } from "./directives/autofocus";
import { keyclick } from "./directives/keyclick";
import { hscroll } from "./directives/hscroll";
import showpass from "./directives/showpass";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";

import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(autoAnimatePlugin);
app.use(VueAwesomePaginate);

app.directive("focus", autofocus);
app.directive("keyclick", keyclick);
app.directive("hscroll", hscroll);
app.directive("showpass", showpass);

app.mount("#app");
